
<template>

<v-container grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card dark color="success">
            <v-card-text class="display-1 text-xs-center">14</v-card-text>
          </v-card>
        </v-flex>
        <v-flex  xs12>
          <v-card dark color="secondary">
             <v-date-picker 
             v-model="picker2"
              full-width
              locale="es-cl"
               color="green lighten-1" header-color="primary"></v-date-picker>
          </v-card>
        </v-flex>
        {{picker2}}
    
       </v-layout>
</v-container>
 
</template>

<script>
// @ is an alias to /src
import   restclient    from "axios";


export default {
  name: 'grid',
  components: {

  },
    data () {
    return {
      picker: new Date().toISOString().substr(0, 10),
      picker2: new Date().toISOString().substr(0, 10)
    }
    },
    methods:{
        async getdolar(){

         let datos= await restclient.get('https://mindicador.cl/api/dolar');
              console.log(datos);
        }        

    }
    ,created(){
     this.getdolar();

    }
}
</script>